export const SOCKET_PATH = 'https://im.igyl.com/'


// WEBPACK FOOTER //
// ./src/ws.js